import Icon from 'components/Icon/Icon';
import { useTranslation } from 'react-i18next';
import { Operator } from 'types/Operator';
import { Profile } from 'types/Profile';

function ProfileBadges({
  profile,
  noText = false,
  isSmall = false,
  classname = '',
}: {
  profile: Profile | Operator;
  noText?: boolean;
  isSmall?: boolean;
  classname?: string;
}) {
  const { t } = useTranslation();
  function isProfile(obj: Profile | Operator): obj is Profile {
    return 'training' in obj;
  }

  return (
    <div className={`flex flex-row gap-2 items-center justify-start ${classname}`}>
      {isProfile(profile) ? (
        <div
          className={`flex items-center gap-1 font-normal leading-[0] text-center text-white bg-slate-500 rounded-full shrink-0 ${
            isSmall ? 'px-1 py-0.5' : 'px-2 py-1'
          }`}
        >
          <Icon name="UserIcon" className={`${isSmall ? 'w-4 h-4' : 'w-5 h-5'}`} />
          {!noText && `${t('common.student')}`}
        </div>
      ) : (
        <div
          className={`flex items-center gap-1 font-normal leading-[0] text-center text-white bg-slate-500 rounded-full shrink-0 ${
            isSmall ? 'px-1 py-0.5' : 'px-2 py-1'
          }`}
        >
          <Icon name="Mediator" className={`${isSmall ? 'w-4 h-4' : 'w-5 h-5'}`} />
          {!noText && ` ${t('common.mediator')}`}
        </div>
      )}
    </div>
  );
}

export default ProfileBadges;
